export default function FAQ() {
  return (
    <div className="px-6 py-20">
      <div className="mx-auto max-w-4xl">
        {/* Header */}
        <div className="text-center mb-16 px-4">
          <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight">Frequently Asked Questions</h1>
          <p className="mt-4 text-base sm:text-lg text-slate-400">
            Everything you need to know about SwiftDev Toolkit
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-6">
          {/* FAQ 1 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">What is SwiftDev Toolkit?</h3>
            <p className="text-slate-400 leading-relaxed">
              SwiftDev Toolkit is a native macOS app that turns messy build output into structured reports. Instead of scrolling through terminal logs, you get visual dashboards and AI-ready exports — perfect for pasting into ChatGPT, Claude, or Cursor.
            </p>
          </div>

          {/* FAQ 2 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">How is this different from using the terminal?</h3>
            <p className="text-slate-400 leading-relaxed">
              Terminal gives you thousands of lines of raw output. SwiftDev Toolkit parses that into visual cards or AI-ready text. One click copies everything — no more manually hunting for error messages or losing context.
            </p>
          </div>

          {/* FAQ 3 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">Does it work with my project?</h3>
            <p className="text-slate-400 leading-relaxed">
              Yes! SwiftDev Toolkit works with any Xcode project or workspace. Supports SwiftUI, UIKit, Swift Package Manager, CocoaPods, and Carthage. Works with iOS, macOS, tvOS, and watchOS projects.
            </p>
          </div>

          {/* FAQ 4 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">Is my code sent to any servers?</h3>
            <p className="text-slate-400 leading-relaxed">
              No. SwiftDev Toolkit is 100% local-first. Everything happens on your Mac. Nothing is transmitted to external servers. Your code stays private.
            </p>
          </div>

          {/* FAQ 5 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">What AI assistants work best with this?</h3>
            <p className="text-slate-400 leading-relaxed">
              SwiftDev Toolkit works great with ChatGPT, Claude, Cursor, Windsurf, and GitHub Copilot. Exports include code context, file paths, and line numbers — everything AI needs to suggest fixes.
            </p>
          </div>

          {/* FAQ 6 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">Can I use this with CI/CD pipelines?</h3>
            <p className="text-slate-400 leading-relaxed">
              SwiftDev Toolkit is designed for local development. It's perfect for pre-commit validation, debugging build failures, and iterating with AI assistance. For CI/CD, you'll still use your existing pipeline (GitHub Actions, Fastlane, etc.). Think of SwiftDev Toolkit as your local build dashboard before you push.
            </p>
          </div>

          {/* FAQ 7 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">What are the system requirements?</h3>
            <p className="text-slate-400 leading-relaxed">
              macOS 14.0 or later and Xcode 15+. Works on both Apple Silicon and Intel Macs. No account or subscription required.
            </p>
          </div>

          {/* FAQ 8 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">Is it keyboard-friendly?</h3>
            <p className="text-slate-400 leading-relaxed">
              Yes! Use <strong className="text-white">Cmd+R</strong> to run builds, <strong className="text-white">Cmd+F</strong> to search output, and <strong className="text-white">Cmd+Shift+E</strong> to export reports. Plus all standard macOS shortcuts.
            </p>
          </div>

          {/* FAQ 9 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">What premium features are available?</h3>
            <p className="text-slate-400 leading-relaxed">
              Premium features include Project Intelligence, Naming Audit, advanced export options, build comparison, unlimited history, and custom themes. Core build, test, and SwiftLint features are free.
            </p>
          </div>

          {/* FAQ 10 */}
          <div className="glass-card rounded-3xl p-8">
            <h3 className="text-xl font-semibold text-white mb-3">How do I get support?</h3>
            <p className="text-slate-400 leading-relaxed">
              Email us at{' '}
              <a 
                href="mailto:hello@swiftdevtoolkit.com" 
                className="text-brand-400 hover:text-brand-300 transition-colors font-medium hover:underline"
              >
                hello@swiftdevtoolkit.com
              </a>{' '}
              for help, feature requests, or bug reports. We typically respond within 24 hours.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
